/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  Flex,
  Image,
  Stack,
  Text,
  Icon,
  Center,
  VisuallyHidden,
  ListItem,
  chakra,
  keyframes,
  SimpleGrid,
  Heading,
  Container,
  HStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  IconButton,
  useColorModeValue,
  useDisclosure,
  Popover,
  PopoverTrigger,
  StackDivider,
  Avatar,
  VStack,
  List,
  ListIcon,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import { FaArrowRight, FaCheckCircle, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { getSingleDocumentFirebase } from '../../Api/firebaseApi';
import { ChevronRightIcon, CloseIcon, HamburgerIcon } from '@chakra-ui/icons';
import { IoAnalyticsSharp, IoSearchSharp } from 'react-icons/io5';
import { IoLogoBitcoin } from 'react-icons/io';

function PriceWrapper(props) {
  const { children } = props

  return (
    <Box
      mb={4}
      shadow='base'
      borderWidth='1px'
      alignSelf={{ base: 'center', lg: 'flex-start' }}
      borderColor={useColorModeValue('gray.200', 'gray.500')}
      borderRadius={'xl'}>
      {children}
    </Box>
  )
}

const HomeMainPage = () => {
  const navigate = useNavigate()
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
  const [isVisible4, setIsVisible4] = useState(false);
  const [isVisible5, setIsVisible5] = useState(false);
  const [isVisible6, setIsVisible6] = useState(false);
  const [isVisible7, setIsVisible7] = useState(false);
  const [isVisible8, setIsVisible8] = useState(false);
  const [isVisible9, setIsVisible9] = useState(false);
  const { isOpen, onToggle } = useDisclosure()
  const [organizationConfig, setOrganzationConfig] = useState()
  const organisasi = [
    {
      department: 'marketing', divisi: [
        { name: 'digital marketing', subDivisi: ['facebook ads', 'google ads', 'tiktok ads'] },
        { name: 'kol', subDivisi: ['kol instagram', 'kol tiktok'] },
        { name: 'social media', subDivisi: ['copywriter', 'story telling script'] },
      ]
    },
    {
      department: 'finance', divisi: [
        { name: 'acconting', subDivisi: ['coa', 'google ads', 'tiktok ads'] },
        { name: 'finance', subDivisi: ['kol instagram', 'kol tiktok'] },
        { name: 'tax', subDivisi: ['kol instagram', 'kol tiktok'] },
      ]
    },
    {
      department: 'creative', divisi: [
        { name: 'design', subDivisi: ['graphic design', 'tiktok ads'] },
        { name: 'copywriting', subDivisi: ['headline', 'website copy', 'seo writer', 'story telling script writer'] },
        { name: 'production', subDivisi: ['video editor', 'image editor', 'photographer'] },
      ]
    },
  ]

  const faq = [
    { q: 'Apa itu CRM?', a: 'CRM adalah kependekan dari Customer Relationship Management. Ini adalah strategi bisnis untuk mengelola interaksi dan hubungan dengan pelanggan Anda.' },
    { q: 'Apa keuntungan menggunakan CRM?', a: 'CRM membantu Anda memahami pelanggan Anda lebih baik, meningkatkan retensi pelanggan, meningkatkan penjualan, dan mengoptimalkan proses bisnis Anda.' },
    { q: 'Bagaimana cara memulai menggunakan CRM?', a: 'Anda dapat memulai dengan mendaftar untuk layanan CRM dan mengimpor data pelanggan Anda ke dalam platform CRM tersebut.' },
    { q: 'Apakah CRM mudah digunakan?', a: 'CRM dirancang untuk menjadi user-friendly, meskipun beberapa platform mungkin memerlukan pelatihan awal untuk memahami fitur-fiturnya sepenuhnya.' },
    { q: 'Apakah ada dukungan pelanggan untuk pengguna CRM?', a: 'Umumnya, platform CRM menyediakan dukungan pelanggan untuk membantu pengguna dalam mengatasi masalah dan menjawab pertanyaan mereka.' },
  ];

  const communityVideo = [
    {
      title: 'Flowise AI Tutorial #1 - Introduction & Setup',
      image: 'https://www.youtube.com/embed/tD6fwQyUIJE',
    },
    {
      title: 'How to Build an AI Document Chatbot in 10 Minutes',
      image: 'https://www.youtube.com/embed/riXpu1tHzl0'
    },
    {
      title: 'Flowise is an open source no-code UI visual tool to build 🦜🔗LangChain applications',
      image: 'https://www.youtube.com/embed/CovAPtQPU0k'
    },
    {
      title: 'Flowise: No Code ChatBot Building Platform: LangChain',
      image: 'https://www.youtube.com/embed/Q7_dKkosJY4'
    },
    {
      title: 'Build a No-Code Chat-with-PDF LangChain app using Flowise and Bubble',
      image: 'https://www.youtube.com/embed/kOwmPe8aLAA'
    },
    {
      title: 'Flowise AI: Create LLM Apps with NO Code - FREE Opensource LangChain Apps',
      image: 'https://www.youtube.com/embed/tD6fwQyUIJEhttps://www.youtube.com/embed/kvvBUz0q-6I'
    },
  ]

  const imageLogo = [
    {
      image: 'https://cdn.msgsndr.com/location%2FO05Yo0bfX94TBxoHHhla%2Fimages%2Fbcbf08ce-4e67-4305-b634-80c46ef1ac32.png?alt=media'
    },
    {
      image: 'https://d2jnbxtr5v4vqu.cloudfront.net/filemanager/Maul/logo-org-importir1-2021_10_05_09_58_32.png?v=1.0'
    },
    {
      image: 'https://klamby.id/cdn/shop/files/Logo_klamby_baru_banget.png?v=1643345083'
    },
    {
      image: 'https://ditusi.co.id/assets/images/logo-white.png'
    },

    {
      image: 'https://eklesclinic.com/wp-content/uploads/2023/02/LOGO-EKLES-Large-New.png'
    },
    {
      image: 'https://d2jnbxtr5v4vqu.cloudfront.net/filemanager/Maul/logo-org-importir1-2021_10_05_09_58_32.png?v=1.0'
    },
    {
      image: 'https://klamby.id/cdn/shop/files/Logo_klamby_baru_banget.png?v=1643345083'
    },
    {
      image: 'https://ditusi.co.id/assets/images/logo-white.png'
    },
    {
      image: 'https://cdn.msgsndr.com/location%2FO05Yo0bfX94TBxoHHhla%2Fimages%2Fbcbf08ce-4e67-4305-b634-80c46ef1ac32.png?alt=media'
    },
    {
      image: 'https://d2jnbxtr5v4vqu.cloudfront.net/filemanager/Maul/logo-org-importir1-2021_10_05_09_58_32.png?v=1.0'
    },
    {
      image: 'https://klamby.id/cdn/shop/files/Logo_klamby_baru_banget.png?v=1643345083'
    },
    {
      image: 'https://ditusi.co.id/assets/images/logo-white.png'
    },
  ]

  const animationKeyFrames = keyframes`
        from {
            transform: translateX(0)
        }
        to {
            transform: translateX(-100%)
    }`
  const animation = `${animationKeyFrames} 30s infinite linear`;

  const Logo = (props) => {
    return (
      <svg height={32} viewBox='0 0 120 28' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path
          d='M34.87 8.07H37.87V20.2H34.87V8.07ZM39.06 15.62C39.06 12.62 40.9 10.83 43.74 10.83C46.58 10.83 48.42 12.62 48.42 15.62C48.42 18.62 46.62 20.42 43.74 20.42C40.86 20.42 39.06 18.67 39.06 15.62ZM45.41 15.62C45.41 13.97 44.76 13 43.74 13C42.72 13 42.08 14 42.08 15.62C42.08 17.24 42.71 18.22 43.74 18.22C44.77 18.22 45.41 17.3 45.41 15.63V15.62ZM49.55 20.79H52.43C52.5671 21.0945 52.7988 21.3466 53.0907 21.5088C53.3826 21.6709 53.7191 21.7345 54.05 21.69C55.19 21.69 55.79 21.07 55.79 20.17V18.49H55.73C55.491 19.0049 55.1031 19.4363 54.6165 19.7287C54.1299 20.021 53.5668 20.1608 53 20.13C50.81 20.13 49.36 18.46 49.36 15.59C49.36 12.72 50.74 10.91 53.04 10.91C53.6246 10.8871 54.2022 11.0434 54.6955 11.3579C55.1888 11.6725 55.5742 12.1303 55.8 12.67V12.67V11H58.8V20.1C58.8 22.29 56.87 23.65 54.02 23.65C51.37 23.65 49.72 22.46 49.55 20.8V20.79ZM55.8 15.61C55.8 14.15 55.13 13.23 54.07 13.23C53.01 13.23 52.36 14.14 52.36 15.61C52.36 17.08 53 17.91 54.07 17.91C55.14 17.91 55.8 17.1 55.8 15.62V15.61ZM59.93 15.61C59.93 12.61 61.77 10.82 64.61 10.82C67.45 10.82 69.3 12.61 69.3 15.61C69.3 18.61 67.5 20.41 64.61 20.41C61.72 20.41 59.93 18.67 59.93 15.62V15.61ZM66.28 15.61C66.28 13.96 65.63 12.99 64.61 12.99C63.59 12.99 63 14 63 15.63C63 17.26 63.63 18.23 64.65 18.23C65.67 18.23 66.28 17.3 66.28 15.63V15.61ZM70.44 8.82C70.4321 8.51711 70.5144 8.2187 70.6763 7.96261C70.8383 7.70651 71.0726 7.50427 71.3496 7.38151C71.6266 7.25875 71.9338 7.221 72.2323 7.27305C72.5308 7.32511 72.8071 7.46462 73.0262 7.67389C73.2454 7.88317 73.3974 8.1528 73.4631 8.44859C73.5288 8.74438 73.5052 9.05301 73.3952 9.33536C73.2853 9.61772 73.094 9.86108 72.8456 10.0346C72.5973 10.2081 72.3029 10.304 72 10.31C71.7992 10.3238 71.5977 10.2959 71.4082 10.2281C71.2186 10.1603 71.0452 10.0541 70.8987 9.91601C70.7522 9.77796 70.6358 9.61111 70.5569 9.42594C70.4779 9.24077 70.4381 9.04128 70.44 8.84V8.82ZM70.44 11.02H73.44V20.2H70.44V11.02ZM84.33 15.61C84.33 18.61 83 20.32 80.72 20.32C80.1354 20.3575 79.5533 20.2146 79.0525 19.9106C78.5517 19.6065 78.1564 19.156 77.92 18.62H77.86V23.14H74.86V11H77.86V12.64H77.92C78.1454 12.0951 78.5332 11.6329 79.0306 11.3162C79.528 10.9995 80.1109 10.8437 80.7 10.87C83 10.91 84.37 12.63 84.37 15.63L84.33 15.61ZM81.33 15.61C81.33 14.15 80.66 13.22 79.61 13.22C78.56 13.22 77.89 14.16 77.88 15.61C77.87 17.06 78.56 17.99 79.61 17.99C80.66 17.99 81.33 17.08 81.33 15.63V15.61ZM89.48 10.81C91.97 10.81 93.48 11.99 93.55 13.88H90.82C90.82 13.23 90.28 12.82 89.45 12.82C88.62 12.82 88.25 13.14 88.25 13.61C88.25 14.08 88.58 14.23 89.25 14.37L91.17 14.76C93 15.15 93.78 15.89 93.78 17.28C93.78 19.18 92.05 20.4 89.5 20.4C86.95 20.4 85.28 19.18 85.15 17.31H88.04C88.13 17.99 88.67 18.39 89.55 18.39C90.43 18.39 90.83 18.1 90.83 17.62C90.83 17.14 90.55 17.04 89.83 16.89L88.1 16.52C86.31 16.15 85.37 15.2 85.37 13.8C85.39 12 87 10.83 89.48 10.83V10.81ZM103.79 20.18H100.9V18.47H100.84C100.681 19.0441 100.331 19.5466 99.8468 19.8941C99.3629 20.2415 98.7748 20.413 98.18 20.38C97.7242 20.4059 97.2682 20.3337 96.8427 20.1682C96.4172 20.0027 96.0322 19.7479 95.7137 19.4208C95.3952 19.0938 95.1505 18.7021 94.9964 18.2724C94.8422 17.8427 94.7821 17.3849 94.82 16.93V11H97.82V16.24C97.82 17.33 98.38 17.91 99.31 17.91C99.5281 17.9104 99.7437 17.8643 99.9425 17.7746C100.141 17.6849 100.319 17.5537 100.463 17.3899C100.606 17.226 100.714 17.0333 100.777 16.8247C100.84 16.616 100.859 16.3962 100.83 16.18V11H103.83L103.79 20.18ZM105.24 11H108.14V12.77H108.2C108.359 12.2035 108.702 11.7057 109.174 11.3547C109.646 11.0037 110.222 10.8191 110.81 10.83C111.409 10.7821 112.003 10.9612 112.476 11.3318C112.948 11.7024 113.264 12.2372 113.36 12.83H113.42C113.601 12.2309 113.977 11.7093 114.488 11.3472C114.998 10.9851 115.615 10.8031 116.24 10.83C116.648 10.8163 117.054 10.8886 117.432 11.0422C117.811 11.1957 118.152 11.4272 118.435 11.7214C118.718 12.0157 118.936 12.3662 119.075 12.7501C119.213 13.134 119.27 13.5429 119.24 13.95V20.2H116.24V14.75C116.24 13.75 115.79 13.29 114.95 13.29C114.763 13.2884 114.577 13.327 114.406 13.4032C114.235 13.4794 114.082 13.5914 113.958 13.7317C113.834 13.872 113.741 14.0372 113.686 14.2163C113.631 14.3955 113.616 14.5843 113.64 14.77V20.2H110.79V14.71C110.79 13.79 110.34 13.29 109.52 13.29C109.331 13.2901 109.143 13.3303 108.971 13.408C108.798 13.4858 108.643 13.5993 108.518 13.741C108.392 13.8827 108.298 14.0495 108.241 14.2304C108.185 14.4112 108.167 14.6019 108.19 14.79V20.2H105.19L105.24 11Z'
          fill='currentColor'
        />
        <path
          d='M26.48 8.62001C25.9711 7.45637 25.2975 6.37195 24.48 5.40001C23.2714 3.92035 21.7632 2.71341 20.0546 1.85862C18.346 1.00383 16.4758 0.520582 14.567 0.440674C12.6582 0.360766 10.7541 0.68601 8.98 1.395C7.20594 2.104 5.60214 3.18067 4.27417 4.55414C2.94619 5.92762 1.92414 7.56676 1.27529 9.36369C0.626436 11.1606 0.365493 13.0746 0.509634 14.9796C0.653775 16.8847 1.19973 18.7376 2.11157 20.4164C3.02341 22.0953 4.28046 23.562 5.79998 24.72C6.77498 25.4779 7.85233 26.094 8.99998 26.55C10.609 27.2094 12.3311 27.549 14.07 27.55C17.6594 27.5421 21.0992 26.1113 23.6354 23.5713C26.1717 21.0314 27.5973 17.5894 27.6 14C27.6026 12.1485 27.2213 10.3166 26.48 8.62001V8.62001ZM14.06 3.19001C15.6215 3.18984 17.1642 3.53115 18.58 4.19001V4.19001C18.2347 4.33918 17.8718 4.44337 17.5 4.50001C16.2766 4.67711 15.1432 5.24509 14.2691 6.11918C13.3951 6.99328 12.8271 8.12661 12.65 9.35001C12.5722 10.0361 12.2602 10.6744 11.7665 11.1572C11.2728 11.64 10.6277 11.9377 9.93998 12C8.71657 12.1771 7.58324 12.7451 6.70915 13.6192C5.83505 14.4933 5.26707 15.6266 5.08998 16.85C5.03002 17.5024 4.75167 18.1155 4.29998 18.59V18.59C3.52063 16.9433 3.17053 15.1261 3.28225 13.3077C3.39397 11.4893 3.96388 9.72871 4.93895 8.18976C5.91401 6.65081 7.26255 5.38353 8.85905 4.50586C10.4555 3.62819 12.2481 3.16865 14.07 3.17001L14.06 3.19001ZM5.78998 21C5.90998 20.89 6.02998 20.79 6.14998 20.67C7.03963 19.8075 7.61069 18.6689 7.76998 17.44C7.83456 16.7493 8.14298 16.1041 8.63998 15.62C9.11822 15.1222 9.76195 14.8163 10.45 14.76C11.6734 14.5829 12.8067 14.0149 13.6808 13.1408C14.5549 12.2667 15.1229 11.1334 15.3 9.91001C15.3432 9.18752 15.6533 8.50685 16.17 8.00001C16.66 7.51186 17.3099 7.21711 18 7.17001C19.1239 7.01537 20.1721 6.51573 21 5.74001C21.9426 6.52208 22.7413 7.46291 23.36 8.52001C23.322 8.57136 23.2784 8.61832 23.23 8.66001C22.7526 9.16221 22.1098 9.47477 21.42 9.54001C20.1953 9.71401 19.0603 10.281 18.1856 11.1557C17.311 12.0303 16.744 13.1654 16.57 14.39C16.4995 15.0784 16.1932 15.7213 15.7029 16.2098C15.2127 16.6982 14.5687 17.0021 13.88 17.07C12.653 17.2458 11.5154 17.8126 10.6363 18.6863C9.75713 19.5601 9.18328 20.6941 8.99998 21.92C8.94616 22.4087 8.77832 22.878 8.50998 23.29C7.48397 22.6808 6.56506 21.9072 5.78998 21V21ZM14.06 24.86C13.0452 24.8611 12.0354 24.7197 11.06 24.44C11.3936 23.818 11.6106 23.1402 11.7 22.44C11.7701 21.7531 12.0749 21.1114 12.5632 20.6232C13.0514 20.135 13.6931 19.8301 14.38 19.76C15.6052 19.5849 16.7408 19.0178 17.6168 18.1435C18.4929 17.2693 19.0624 16.1349 19.24 14.91C19.3101 14.2231 19.6149 13.5814 20.1032 13.0932C20.5914 12.605 21.2331 12.3001 21.92 12.23C22.842 12.1101 23.7208 11.7668 24.48 11.23C24.9015 12.8279 24.9515 14.5012 24.626 16.1214C24.3004 17.7416 23.6081 19.2657 22.6021 20.5768C21.5961 21.8879 20.3031 22.9511 18.8224 23.6849C17.3417 24.4187 15.7125 24.8036 14.06 24.81V24.86Z'
          fill='#2F855A'
        />
      </svg>
    )
  }

  const SocialButton = ({
    children,
    label,
    href,
  }) => {
    return (
      <chakra.button
        bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
        rounded={'full'}
        w={8}
        h={8}
        cursor={'pointer'}
        as={'a'}
        href={href}
        display={'inline-flex'}
        alignItems={'center'}
        justifyContent={'center'}
        transition={'background 0.3s ease'}
        _hover={{
          bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
        }}>
        <VisuallyHidden>{label}</VisuallyHidden>
        {children}
      </chakra.button>
    )
  }

  const ListHeader = ({ children }) => {
    return (
      <Text fontWeight={'500'} fontSize={'lg'} mb={2}>
        {children}
      </Text>
    )
  }

  const linearColor = 'linear(to-r, #FFA500, #ffd600)'



  const DesktopSubNav = ({ label, href, subLabel }) => {
    return (
      <Box
        as='a'
        href={href}
        role={'group'}
        display={'block'}
        p={2}
        rounded={'md'}
        _hover={{ bg: useColorModeValue('pink.50', 'gray.900') }}>
        <Stack direction={'row'} align={'center'}>
          <Box>
            <Text
              transition={'all .3s ease'}
              _groupHover={{ color: 'pink.400' }}
              fontWeight={500}>
              {label}
            </Text>
            <Text fontSize={'sm'}>{subLabel}</Text>
          </Box>
          <Flex
            transition={'all .3s ease'}
            transform={'translateX(-10px)'}
            opacity={0}
            _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
            justify={'flex-end'}
            align={'center'}
            flex={1}>
            <Icon color={'pink.400'} w={5} h={5} as={ChevronRightIcon} />
          </Flex>
        </Stack>
      </Box>
    )
  }

  const NAV_ITEMS = [
    {
      label: 'Feature',
      ref: 'feature'
    },
    {
      label: 'Shipping',
      ref: 'shipping'
    },
    {
      label: 'Payment',
      ref: 'payment',
    },
    {
      label: 'Testimonial',
      ref: 'testimoni',
    },
    {
      label: 'Price',
      ref: 'price',
    },
    {
      label: 'FAQ',
      ref: 'faq',
    },
  ]

  const DesktopNav = () => {
    const linkColor = useColorModeValue('gray.600', 'gray.200');
    const linkHoverColor = useColorModeValue('gray.800', 'white');
    const popoverContentBgColor = useColorModeValue('white', 'gray.800');

    const scrollToSection = (ref) => {
      const element = document.getElementById(ref);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };

    return (
      <Stack direction={'row'} spacing={4}>
        {NAV_ITEMS.map((navItem) => (
          <Box key={navItem.label} mt={'4%'}>
            <Popover trigger={'hover'} placement={'bottom-start'}>
              <PopoverTrigger>
                <Box
                  as='a'
                  p={2}
                  cursor='pointer'
                  fontSize={'sm'}
                  fontWeight={500}
                  color={linkColor}
                  _hover={{
                    textDecoration: 'none',
                    color: linkHoverColor,
                  }}
                  onClick={() => scrollToSection(navItem.ref)}
                >
                  {navItem.label}
                </Box>
              </PopoverTrigger>
            </Popover>
          </Box>
        ))}
      </Stack>
    );
  };

  const getConfig = async () => {
    try {
      const res = await getSingleDocumentFirebase('config', 'karyawanAi')
      console.log(res.divisi)
      setOrganzationConfig(res.divisi)
    } catch (error) {
      console.log(error.message)
    }
  }

  const Feature = ({ text, icon, iconBg }) => {
    return (
      <Stack direction={'row'} align={'center'}>
        <Flex w={8} h={8} align={'center'} justify={'center'} rounded={'full'} bg={iconBg}>
          {icon}
        </Flex>
        <Text fontWeight={600}>{text}</Text>
      </Stack>
    )
  }



  const Testimonial = (props) => {
    const { children } = props

    return <Box>{children}</Box>
  }

  const TestimonialContent = (props) => {
    const { children } = props

    return (
      <Stack
        bg={useColorModeValue('white', 'gray.800')}
        boxShadow={'lg'}
        p={8}
        rounded={'xl'}
        align={'center'}
        pos={'relative'}
      // _after={{
      //   content: '',
      //   w: 0,
      //   h: 0,
      //   borderLeft: 'solid transparent',
      //   borderLeftWidth: 16,
      //   borderRight: 'solid transparent',
      //   borderRightWidth: 16,
      //   borderTop: 'solid',
      //   borderTopWidth: 16,
      //   borderTopColor: useColorModeValue('white', 'gray.800'),
      //   pos: 'absolute',
      //   bottom: '-16px',
      //   left: '50%',
      //   transform: 'translateX(-50%)',
      // }}
      >
        {children}
      </Stack>
    )
  }

  const TestimonialHeading = (props) => {
    const { children } = props

    return (
      <Heading as={'h3'} fontSize={'xl'}>
        {children}
      </Heading>
    )
  }

  const TestimonialText = (props) => {
    const { children } = props

    return (
      <Text
        textAlign={'center'}
        color={useColorModeValue('gray.600', 'gray.400')}
        fontSize={'sm'}>
        {children}
      </Text>
    )
  }

  const TestimonialAvatar = ({
    src,
    name,
    title,
  }) => {
    return (
      <Flex align={'center'} mt={8} direction={'column'}>
        <Avatar src={src} mb={2} />
        <Stack spacing={-1} align={'center'}>
          <Text fontWeight={600}>{name}</Text>
          <Text fontSize={'sm'} color={useColorModeValue('gray.600', 'gray.400')}>
            {title}
          </Text>
        </Stack>
      </Flex>
    )
  }

  useEffect(() => {
    getConfig()
    return () => {
      setOrganzationConfig()
    }

  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Tentukan kapan section muncul
      if (scrollPosition > 100) {
        setIsVisible(true);
      } if (scrollPosition > 200) {
        setIsVisible1(true);
      } if (scrollPosition > 300) {
        setIsVisible2(true);
      } if (scrollPosition > 400) {
        setIsVisible3(true);
      } if (scrollPosition > 500) {
        setIsVisible4(true);
        setIsVisible5(true);
        setIsVisible6(true);
        setIsVisible7(true);
        setIsVisible8(true);
        setIsVisible9(true);
      } else {
        setIsVisible(false);
        setIsVisible1(false);
        setIsVisible2(false);
        setIsVisible3(false);
        setIsVisible4(false);
        setIsVisible5(false);
        setIsVisible6(false);
        setIsVisible7(false);
        setIsVisible8(false);
        setIsVisible9(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Box>
        <Flex
          bg={useColorModeValue('white', 'gray.800')}
          color={useColorModeValue('gray.600', 'white')}
          minH={'60px'}
          py={{ base: 2 }}
          px={{ base: 4 }}
          borderBottom={1}
          // borderStyle={'solid'}
          // borderColor={useColorModeValue('gray.200', 'gray.900')}
          align={'center'}>
          <Flex
            flex={{ base: 1, md: 'auto' }}
            ml={{ base: -2 }}
            display={{ base: 'flex', md: 'none' }}>
            <IconButton
              onClick={onToggle}
              icon={isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />}
              variant={'ghost'}
              aria-label={'Toggle Navigation'}
            />
          </Flex>
          <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>
            {/* <Text
              textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
              fontFamily={'heading'}
              color={useColorModeValue('gray.800', 'white')}>
              Logo
            </Text> */}
            <Image src='https://cdn.orderonline.id/uploads/2582751705286171607.png' boxSize={'15%'} ml={'10%'} />
            <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
              <DesktopNav />
            </Flex>
          </Flex>

          <Stack
            flex={{ base: 1, md: 0 }}
            justify={'flex-end'}
            direction={'row'}
            spacing={6}
            mr={'10%'}>
            <motion.div
              className='box'
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: 'spring', stiffness: 400, damping: 17 }}
            >
              <Button as={'a'} fontSize={'sm'} fontWeight={400} variant={'link'} href={'#'} mt={'23%'} onClick={() => navigate('/login')}>
                Sign In
              </Button>
            </motion.div>
            <motion.div
              className='box'
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: 'spring', stiffness: 400, damping: 17 }}
            >
              <Button
                as={'a'}
                display={{ base: 'none', md: 'inline-flex' }}
                fontSize={'sm'}
                fontWeight={600}
                color={'white'}
                bg={'pink.400'}
                href={'#'}
                _hover={{
                  bg: 'pink.300',
                }}>
                Sign Up
              </Button>
            </motion.div>
          </Stack>
        </Flex>
      </Box>

      <motion.div
        className='box'
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        transition={{ type: 'spring', stiffness: 400, damping: 17 }}
      />
      <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}
        bgImage={'https://www.nesabamedia.com/wp-content/uploads/2021/12/Contoh-Aplikasi-CRM-Berbasis-Desktop.png'}
        bgRepeat={false}
        backgroundSize='cover'
        backgroundPosition='center'
      >

        <Flex p={8} flex={1} align={'center'} justify={'flex-start'} bgGradient='linear(to-r, blue.400, rgba(0,0,0,0))'>
          <Stack spacing={6} w={'full'} maxW={'lg'} mx={10}>
            <Heading fontSize={{ base: '3xl', md: '4xl', lg: 'full' }} color='white'>
              <Text
                as={'span'}
                position={'relative'}
              // _after={{
              //   // content: '\'\'',
              //   width: 'full',
              //   height: useBreakpointValue({ base: '20%', md: '30%' }),
              //   position: 'absolute',
              //   bottom: 1,
              //   left: 0,
              //   bg: 'blue.400',
              //   zIndex: -1,
              // }}
              >
                Atur sales dan customers anda dengan
              </Text>
              <br />{' '}
              <Text as={'span'}>
                Deoapp Customer Relationship Management (CRM)
              </Text>{' '}
            </Heading>
            <Text fontSize={{ base: 'md', lg: 'lg' }} color={'white'}>
              The project board is an exclusive resource for contract work. It&apos;s
              perfect for freelancers, agencies, and moonlighters.
            </Text>
            <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
              <motion.div
                className='box'
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
                transition={{ type: 'spring', stiffness: 400, damping: 17 }}
              >
                <Button
                  rounded={'full'}
                  bg={'blue.400'}
                  color={'white'}
                  onClick={() => navigate('/login')}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                  Login
                </Button>
              </motion.div>
              <motion.div
                className='box'
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
                transition={{ type: 'spring', stiffness: 400, damping: 17 }}
              >
                <Button rounded={'full'}>Sign Up</Button>
              </motion.div>
            </Stack>
          </Stack>
        </Flex>
      </Stack>

      <Stack bgColor={'rgb(21,23,25)'}>

        <Stack p={'0.5em'} bg={'white'}>
          <Box
            justifyContent={'center'}
          >
            <Flex
              py={'5%'}
              direction={{ base: 'column', md: 'column' }}
              justifyContent={'center'}
              alignItems={'center'}
              fontSize={{ base: '10px', md: '18px', lg: '27px' }}
            >
              <Text color={'black'} alignContent={'center'}>CRM DeoApp dengan fitur canggih dan dukungan pelanggan terbaik di kelasnya</Text>
            </Flex>
          </Box>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 2.5 }}
          >
            <section id='1'>
              <Stack p={'1em'} bg='#F0F8FF'>
                <Box justifyContent={'center'} alignItems={'center'} fontSize={{ base: '10px', md: '18px', lg: '27px' }}>
                  <Text textAlign='center'>Seluruh Proses Jualan Online Dengan Satu Akun Deoapp CRM</Text>
                </Box>
                <Box>
                  <SimpleGrid columns={7} spacing={4} mt={'3%'}>
                    <Box display={'grid'} placeItems={'center'}>
                      <Image src='https://kasirpintar.co.id/design_v2/images/ios/tampilan_mudah_lpios.webp' />
                      <Text>Contoh</Text>
                      <Text>Contoh</Text>
                    </Box>
                    <Box >
                      <Box mt={'30%'}>
                        <FaArrowRight size={'40%'} />
                      </Box>
                    </Box>
                    <Box display={'grid'} placeItems={'center'}>
                      <Image src='https://kasirpintar.co.id/design_v2/images/ios/tampilan_mudah_lpios.webp' />
                      <Text>Contoh</Text>
                      <Text>Contoh</Text>
                    </Box>
                    <Box >
                      <Box mt={'30%'}>
                        <FaArrowRight size={'40%'} />
                      </Box>
                    </Box>
                    <Box display={'grid'} placeItems={'center'}>
                      <Image src='https://kasirpintar.co.id/design_v2/images/ios/tampilan_mudah_lpios.webp' />
                      <Text>Contoh</Text>
                      <Text>Contoh</Text>
                    </Box>
                    <Box >
                      <Box mt={'30%'}>
                        <FaArrowRight size={'40%'} />
                      </Box>
                    </Box>
                    <Box display={'grid'} placeItems={'center'}>
                      <Image src='https://kasirpintar.co.id/design_v2/images/ios/tampilan_mudah_lpios.webp' />
                      <Text>Contoh</Text>
                      <Text>Contoh</Text>
                    </Box>
                  </SimpleGrid>
                </Box>
              </Stack>
            </section>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible1 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 2.5 }}
          >
            <section id='2'>
              <Container maxW={'full'} id='feature'>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} p={'5%'}>
                  <Stack spacing={4}>
                    <Text
                      textTransform={'uppercase'}
                      color={'blue.400'}
                      fontWeight={600}
                      fontSize={'sm'}
                      bg={useColorModeValue('blue.50', 'blue.900')}
                      p={2}
                      alignSelf={'flex-start'}
                      rounded={'md'}>
                      Our Story
                    </Text>
                    <Heading>A digital Product design agency</Heading>
                    <Text color={'gray.500'} fontSize={'lg'}>
                      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                      eirmod tempor invidunt ut labore
                    </Text>
                    <Stack
                      spacing={4}
                      divider={
                        <StackDivider borderColor={useColorModeValue('gray.100', 'gray.700')} />
                      }>
                      <Feature
                        icon={<Icon as={IoAnalyticsSharp} color={'yellow.500'} w={5} h={5} />}
                        iconBg={useColorModeValue('yellow.100', 'yellow.900')}
                        text={'Business Planning'}
                      />
                      <Feature
                        icon={<Icon as={IoLogoBitcoin} color={'green.500'} w={5} h={5} />}
                        iconBg={useColorModeValue('green.100', 'green.900')}
                        text={'Financial Planning'}
                      />
                      <Feature
                        icon={<Icon as={IoSearchSharp} color={'purple.500'} w={5} h={5} />}
                        iconBg={useColorModeValue('purple.100', 'purple.900')}
                        text={'Market Analysis'}
                      />
                    </Stack>
                  </Stack>
                  <Flex>
                    <Image
                      rounded={'md'}
                      alt={'feature image'}
                      src={
                        'https://orderonline.id/wp-content/uploads/2019/03/Systemize-R.png'
                      }
                      objectFit={'cover'}
                    />
                  </Flex>
                </SimpleGrid>
              </Container>
            </section>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 2.5 }}
          >
            <section id='3'>
              <Container maxW={'full'} bg='#F0F8FF'>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} p={'5%'}>
                  <Flex>
                    <Image
                      rounded={'md'}
                      alt={'feature image'}
                      src={
                        'https://orderonline.id/wp-content/uploads/2019/03/Systemize-R.png'
                      }
                      objectFit={'cover'}
                    />
                  </Flex>
                  <Stack spacing={4}>
                    <Text
                      textTransform={'uppercase'}
                      color={'blue.400'}
                      fontWeight={600}
                      fontSize={'sm'}
                      bg={useColorModeValue('blue.50', 'blue.900')}
                      p={2}
                      alignSelf={'flex-start'}
                      rounded={'md'}>
                      Our Story
                    </Text>
                    <Heading>A digital Product design agency</Heading>
                    <Text color={'gray.500'} fontSize={'lg'}>
                      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                      eirmod tempor invidunt ut labore
                    </Text>
                    <Stack
                      spacing={4}
                      divider={
                        <StackDivider borderColor={useColorModeValue('gray.100', 'gray.700')} />
                      }>
                      <Feature
                        icon={<Icon as={IoAnalyticsSharp} color={'yellow.500'} w={5} h={5} />}
                        iconBg={useColorModeValue('yellow.100', 'yellow.900')}
                        text={'Business Planning'}
                      />
                      <Feature
                        icon={<Icon as={IoLogoBitcoin} color={'green.500'} w={5} h={5} />}
                        iconBg={useColorModeValue('green.100', 'green.900')}
                        text={'Financial Planning'}
                      />
                      <Feature
                        icon={<Icon as={IoSearchSharp} color={'purple.500'} w={5} h={5} />}
                        iconBg={useColorModeValue('purple.100', 'purple.900')}
                        text={'Market Analysis'}
                      />
                    </Stack>
                  </Stack>
                </SimpleGrid>
              </Container>
            </section>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible3 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 2.5 }}
          >
            <section id='4'>
              <Container maxW={'full'}>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} p={'5%'}>
                  <Stack spacing={4}>
                    <Text
                      textTransform={'uppercase'}
                      color={'blue.400'}
                      fontWeight={600}
                      fontSize={'sm'}
                      bg={useColorModeValue('blue.50', 'blue.900')}
                      p={2}
                      alignSelf={'flex-start'}
                      rounded={'md'}>
                      Our Story
                    </Text>
                    <Heading>A digital Product design agency</Heading>
                    <Text color={'gray.500'} fontSize={'lg'}>
                      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                      eirmod tempor invidunt ut labore
                    </Text>
                    <Stack
                      spacing={4}
                      divider={
                        <StackDivider borderColor={useColorModeValue('gray.100', 'gray.700')} />
                      }>
                      <Feature
                        icon={<Icon as={IoAnalyticsSharp} color={'yellow.500'} w={5} h={5} />}
                        iconBg={useColorModeValue('yellow.100', 'yellow.900')}
                        text={'Business Planning'}
                      />
                      <Feature
                        icon={<Icon as={IoLogoBitcoin} color={'green.500'} w={5} h={5} />}
                        iconBg={useColorModeValue('green.100', 'green.900')}
                        text={'Financial Planning'}
                      />
                      <Feature
                        icon={<Icon as={IoSearchSharp} color={'purple.500'} w={5} h={5} />}
                        iconBg={useColorModeValue('purple.100', 'purple.900')}
                        text={'Market Analysis'}
                      />
                    </Stack>
                  </Stack>
                  <Flex>
                    <Image
                      rounded={'md'}
                      alt={'feature image'}
                      src={
                        'https://orderonline.id/wp-content/uploads/2019/03/Systemize-R.png'
                      }
                      objectFit={'cover'}
                    />
                  </Flex>
                </SimpleGrid>
              </Container>
            </section>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible4 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 2.5 }}
          >
            <section id='5'>
              <Stack p={'1em'} bg='#F0F8FF' id='shipping'>
                <Box justifyContent={'center'} alignItems={'center'} fontSize={{ base: '10px', md: '18px', lg: '27px' }}>
                  <Text textAlign='center'>Atur warehouse mu dan integrasikan dengan layanan pengiriman</Text>
                </Box>
                <Box>
                  <SimpleGrid columns={7} spacing={4} mt={'3%'}>
                    <Box>
                      <Image src='https://oexpress.id/wp-content/uploads/2023/04/SATSET-1-150x150.png' />
                    </Box>
                    <Box>
                      <Image src='https://oexpress.id/wp-content/uploads/2023/04/SULTAN-1-150x150.png' />
                    </Box>
                    <Box>
                      <Image src='https://oexpress.id/wp-content/uploads/2023/04/KISS-1-150x150.png' />
                    </Box>
                    <Box>
                      <Image src='https://oexpress.id/wp-content/uploads/2023/04/SERBU-1-150x150.png' />
                    </Box>
                    <Box>
                      <Image src='https://oexpress.id/wp-content/uploads/2023/04/HORE-1-150x150.png' />
                    </Box>
                    <Box>
                      <Image src='https://oexpress.id/wp-content/uploads/2023/04/GOCAP-1-150x150.png' />
                    </Box>
                    <Box>
                      <Image src='https://oexpress.id/wp-content/uploads/2023/04/KECE-1-150x150.png' />
                    </Box>
                  </SimpleGrid>
                </Box>
              </Stack>
            </section>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 2.5 }}
          >
            <section id='6'>
              <Container maxW={'full'}>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} p={'5%'}>
                  <Stack spacing={4} marginY={'50%'}>
                    <Text
                      textTransform={'uppercase'}
                      color={'blue.400'}
                      fontWeight={600}
                      fontSize={'sm'}
                      bg={useColorModeValue('blue.50', 'blue.900')}
                      p={2}
                      alignSelf={'flex-start'}
                      rounded={'md'}>
                      Our Story
                    </Text>
                    <Heading>A digital Product design agency</Heading>
                    <Text color={'gray.500'} fontSize={'lg'}>
                      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                      eirmod tempor invidunt ut labore
                    </Text>
                    <Text color={'black.500'} fontSize={'lg'} textAlign='center'>
                      Klik tombol di bawah untuk informasi lengkap
                    </Text>
                    <Text color={'black.500'} fontSize={'lg'} textAlign='center'>
                      mengenai fitur Logistics:
                    </Text>
                    <Button
                      rounded={'full'}
                      bg={'blue.400'}
                      color={'white'}
                      onClick={() => navigate('/login')}
                      _hover={{
                        bg: 'blue.500',
                      }}>
                      Login
                    </Button>
                  </Stack>
                  <Flex>
                    <Image
                      rounded={'md'}
                      alt={'feature image'}
                      src={
                        'https://orderonline.id/wp-content/uploads/2021/09/level-UP-3b-1.png'
                      }
                      objectFit={'cover'}
                    />
                  </Flex>
                </SimpleGrid>
              </Container>
            </section>
          </motion.div>

          <Stack p={'1em'} bg='#F0F8FF' id='payment' boxShadow='md' borderRadius='md'>
            <Box textAlign='center' fontSize={{ base: '14px', md: '18px', lg: '27px' }} py={4}>
              Mendukung Metode Pembayaran Instant
            </Box>
            <Box justifyContent={'center'} alignContent={'center'} mx={'auto'}>
              <SimpleGrid columns={{ base: 2, md: 4, lg: 6 }} spacing={6} mt={4}>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/10/Visa_Logo.png' boxSize='65%' objectFit='contain' />
                </Box>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/10/200px-mastercard-logo.svg_.png' boxSize='65%' objectFit='contain' />
                </Box>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/10/bca-bank-central-asia-logo-png-transparent-1024x321.png' boxSize='65%' objectFit='contain' />
                </Box>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/10/4-Cara-Transfer-Virtual-Account-BNI-yang-Mudah-Dilakukan.png' boxSize='65%' objectFit='contain' />
                </Box>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/12/Bank_Mandiri_logo_white_bg-1-1024x321.png' boxSize='65%' objectFit='contain' />
                </Box>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/12/TEGVPZGQFAY93GA5FRUU4V3K35TWQZ2GXLYQPAUT-5c63e5a5-1024x267.png' boxSize='65%' objectFit='contain' />
                </Box>
              </SimpleGrid>
              <SimpleGrid columns={{ base: 2, md: 4, lg: 5 }} spacing={6} mt={4}>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/10/o81yliwckjhywelnx13a.png' boxSize='65%' objectFit='contain' />
                </Box>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/10/1280px-Logo_ovo_purple.svg_.png' boxSize='65%' objectFit='contain' />
                </Box>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/11/Logo-ShopeePay.png' boxSize='65%' objectFit='contain' />
                </Box>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/10/Dana_logo.png' boxSize='65%' objectFit='contain' />
                </Box>
                <Box>
                  <Image src='https://orderonline.id/wp-content/uploads/2020/10/ALFAMART_LOGO_BARU.png' boxSize='65%' objectFit='contain' />
                </Box>
              </SimpleGrid>

            </Box>
          </Stack>

          <Box id='testimoni'>
            <Container maxW={'7xl'} py={16} as={Stack} spacing={12}>
              <Stack spacing={0} align={'center'}>
                <Heading>Our Clients Speak</Heading>
                <Text>We have been working with clients around the world</Text>
              </Stack>
              <Stack
                direction={{ base: 'column', md: 'row' }}
                spacing={{ base: 10, md: 4, lg: 10 }}>
                <Testimonial>
                  <TestimonialContent>
                    <TestimonialHeading>Efficient Collaborating</TestimonialHeading>
                    <TestimonialText>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed
                      imperdiet nibh lectus feugiat nunc sem.
                    </TestimonialText>
                  </TestimonialContent>
                  <TestimonialAvatar
                    src={
                      'https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
                    }
                    name={'Jane Cooper'}
                    title={'CEO at ABC Corporation'}
                  />
                </Testimonial>
                <Testimonial>
                  <TestimonialContent>
                    <TestimonialHeading>Intuitive Design</TestimonialHeading>
                    <TestimonialText>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed
                      imperdiet nibh lectus feugiat nunc sem.
                    </TestimonialText>
                  </TestimonialContent>
                  <TestimonialAvatar
                    src={
                      'https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
                    }
                    name={'Jane Cooper'}
                    title={'CEO at ABC Corporation'}
                  />
                </Testimonial>
                <Testimonial>
                  <TestimonialContent>
                    <TestimonialHeading>Mindblowing Service</TestimonialHeading>
                    <TestimonialText>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed
                      imperdiet nibh lectus feugiat nunc sem.
                    </TestimonialText>
                  </TestimonialContent>
                  <TestimonialAvatar
                    src={
                      'https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
                    }
                    name={'Jane Cooper'}
                    title={'CEO at ABC Corporation'}
                  />
                </Testimonial>
              </Stack>
              <Stack
                direction={{ base: 'column', md: 'row' }}
                spacing={{ base: 10, md: 4, lg: 10 }}>
                <Testimonial>
                  <TestimonialContent>
                    <TestimonialHeading>Efficient Collaborating</TestimonialHeading>
                    <TestimonialText>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed
                      imperdiet nibh lectus feugiat nunc sem.
                    </TestimonialText>
                  </TestimonialContent>
                  <TestimonialAvatar
                    src={
                      'https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
                    }
                    name={'Jane Cooper'}
                    title={'CEO at ABC Corporation'}
                  />
                </Testimonial>
                <Testimonial>
                  <TestimonialContent>
                    <TestimonialHeading>Intuitive Design</TestimonialHeading>
                    <TestimonialText>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed
                      imperdiet nibh lectus feugiat nunc sem.
                    </TestimonialText>
                  </TestimonialContent>
                  <TestimonialAvatar
                    src={
                      'https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
                    }
                    name={'Jane Cooper'}
                    title={'CEO at ABC Corporation'}
                  />
                </Testimonial>
                <Testimonial>
                  <TestimonialContent>
                    <TestimonialHeading>Mindblowing Service</TestimonialHeading>
                    <TestimonialText>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed
                      imperdiet nibh lectus feugiat nunc sem.
                    </TestimonialText>
                  </TestimonialContent>
                  <TestimonialAvatar
                    src={
                      'https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80'
                    }
                    name={'Jane Cooper'}
                    title={'CEO at ABC Corporation'}
                  />
                </Testimonial>
              </Stack>
            </Container>
          </Box>

          <Box py={12} bg='#F0F8FF' id='price'>
            <VStack spacing={2} textAlign='center'>
              <Heading as='h1' fontSize='4xl'>
                Pilih plan kamu sesuai kebutuhan
              </Heading>
              <Text fontSize='lg' color={'gray.500'}>
                Dapatkan harga diskon untuk pembelian 1 tahun
              </Text>
            </VStack>
            <Stack
              direction={{ base: 'column', md: 'row' }}
              textAlign='center'
              justify='center'
              spacing={{ base: 4, lg: 10 }}
              py={10}>
              <PriceWrapper>
                <Box py={4} px={12} bg={'white'}>
                  <Text fontWeight='500' fontSize='2xl'>
                    Basic CRM Deoapp
                  </Text>
                  <HStack justifyContent='center'>
                    <Text fontSize='3xl' fontWeight='600'>
                      Rp
                    </Text>
                    <Text fontSize='5xl' fontWeight='900'>
                      149,000
                    </Text>
                    <Text fontSize='3xl' color='gray.500'>
                      /bulan
                    </Text>
                  </HStack>
                </Box>
                <VStack
                  bg={useColorModeValue('gray.50', 'gray.700')}
                  py={4}
                  borderBottomRadius={'xl'}>
                  <List spacing={3} textAlign='start' px={12}>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Unlimited Produk & Varian
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Dashboard Penjualan
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Halaman Checkout
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Integrasi Shipping
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Database Customer
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Customer Pipeline
                    </ListItem>
                  </List>
                  <Box w='80%' pt={7}>
                    <Button
                      w='full'
                      colorScheme='red'
                      variant='outline'
                      onClick={() => {
                        window.open(
                          'http://localhost:3000/checkout?slug=deoapp-crm-1710421965840&utm_campaign=mainpage&variantId=jzDeebQw2BrKAyYjINDK'
                        )
                      }}
                    >
                      Beli
                    </Button>
                  </Box>
                </VStack>
              </PriceWrapper>

              <PriceWrapper>
                <Box position='relative'>
                  <Box
                    position='absolute'
                    top='-16px'
                    left='50%'
                    style={{ transform: 'translate(-50%)' }}>
                    <Text
                      textTransform='uppercase'
                      bg={useColorModeValue('red.300', 'red.700')}
                      px={3}
                      py={1}
                      color={useColorModeValue('gray.900', 'gray.300')}
                      fontSize='sm'
                      fontWeight='600'
                      rounded='xl'>
                      Most Popular
                    </Text>
                  </Box>
                  <Box py={4} px={12} bg={'white'}>
                    <Text fontWeight='500' fontSize='2xl'>
                      Home Business CRM Deoapp
                    </Text>
                    <HStack justifyContent='center'>
                      <Text fontSize='3xl' fontWeight='600'>
                        Rp
                      </Text>
                      <Text fontSize='5xl' fontWeight='900'>
                        249,000
                      </Text>
                      <Text fontSize='3xl' color='gray.500'>
                        /bulan
                      </Text>
                    </HStack>
                  </Box>
                  <VStack
                    bg={useColorModeValue('gray.50', 'gray.700')}
                    py={4}
                    borderBottomRadius={'xl'}>
                    <List spacing={3} textAlign='start' px={12}>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color='green.500' />
                        Custom Checkout Page
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color='green.500' />
                        Custom Pipeline
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color='green.500' />
                        Unlimited Produk & Varian
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color='green.500' />
                        Dashboard Penjualan
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color='green.500' />
                        Halaman Checkout
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color='green.500' />
                        Integrasi Shipping
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color='green.500' />
                        Database Customer
                      </ListItem>
                      <ListItem>
                        <ListIcon as={FaCheckCircle} color='green.500' />
                        Customer Pipeline
                      </ListItem>
                    </List>
                    <Box w='80%' pt={7}>
                      <Button
                        w='full'
                        colorScheme='red'
                        variant='outline'
                        onClick={() => {
                          window.open(
                            'http://localhost:3000/checkout?slug=deoapp-crm-1710421965840&utm_campaign=mainpage&variantId=bnfXDRhXotakEmeADMvX'
                          )
                        }}
                      >
                        Beli
                      </Button>
                    </Box>
                  </VStack>
                </Box>
              </PriceWrapper>
              <PriceWrapper>
                <Box py={4} px={12} bg={'white'}>
                  <Text fontWeight='500' fontSize='2xl'>
                    Enterprise CRM Deoapp
                  </Text>
                  <HStack justifyContent='center'>
                    <Text fontSize='5xl' fontWeight='900'>
                      Hubungi Kami
                    </Text>
                  </HStack>
                </Box>
                <VStack
                  bg={useColorModeValue('gray.50', 'gray.700')}
                  py={4}
                  borderBottomRadius={'xl'}>
                  <List spacing={3} textAlign='start' px={12}>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Chat Bot AI untuk Customer Service integrasi Whatsapp
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Web Builder & Custom Store Front
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Domain
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Custom Checkout Page
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Custom Pipeline
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Unlimited Produk & Varian
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Dashboard Penjualan
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Halaman Checkout
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Integrasi Shipping
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Database Customer
                    </ListItem>
                    <ListItem>
                      <ListIcon as={FaCheckCircle} color='green.500' />
                      Customer Pipeline
                    </ListItem>
                  </List>
                  <Box w='80%' pt={7}>
                    <Button w='full' colorScheme='red'>
                      Hubungi Kami
                    </Button>
                  </Box>
                </VStack>
              </PriceWrapper>
            </Stack>
            {/* <Flex
              // p={50}
              w='full'
              alignItems='center'
              justifyContent='center'
            >
              <Box
                bg='gray.200' // Warna latar belakang abu-abu
                _dark={{
                  bg: 'gray.800',
                }}
                mx={{ lg: 8 }}
                display={{ lg: 'flex' }}
                maxW={{ lg: '5xl' }}
                shadow={{ lg: 'lg' }}
                rounded={{ lg: 'lg' }}
              >
                <Box py={'auto'} px={'auto'} w={{ lg: '30%' }}>
                  <Text fontWeight={'bold'} marginY={'30%'} ml={'7%'} fontSize={'200%'}>Telah Diulas Oleh</Text>
                </Box>
                <Box w={{ lg: '70%' }}>
                  <Box h={{ base: 64, lg: 'full' }} rounded={{ lg: 'lg' }} bgSize='cover'>
                    <SimpleGrid columns={3} spacing={4} p={4}>
                      <Box>
                        <Image src='https://orderonline.id/wp-content/uploads/2022/09/logo-tempo-new1.png' />
                      </Box>
                      <Box>
                        <Image src='https://orderonline.id/wp-content/uploads/2022/09/logo-tempo-new1.png' />
                      </Box>
                      <Box>
                        <Image src='https://orderonline.id/wp-content/uploads/2022/09/logo-tempo-new1.png' />
                      </Box>
                      <Box>
                        <Image src='https://orderonline.id/wp-content/uploads/2022/09/logo-tempo-new1.png' />
                      </Box>
                      <Box>
                        <Image src='https://orderonline.id/wp-content/uploads/2022/09/logo-tempo-new1.png' />
                      </Box>
                      <Box>
                        <Image src='https://orderonline.id/wp-content/uploads/2022/09/logo-tempo-new1.png' />
                      </Box>
                      <Box>
                        <Image src='https://orderonline.id/wp-content/uploads/2022/09/logo-tempo-new1.png' />
                      </Box>
                      <Box>
                        <Image src='https://orderonline.id/wp-content/uploads/2022/09/logo-tempo-new1.png' />
                      </Box>
                      <Box>
                        <Image src='https://orderonline.id/wp-content/uploads/2022/09/logo-tempo-new1.png' />
                      </Box>
                    </SimpleGrid>
                  </Box>
                </Box>
              </Box>
            </Flex> */}

          </Box>

          <Stack mt={'-1%'} bg={'black'}>
            <SimpleGrid columns={2} spacing={10} my={'3%'}>
              <Box my={'25%'} ml={'10%'}>
                <Heading color={'white'}>
                  Terintegrasi Dengan Banyak Tools Lainnya</Heading>
                <Text color={'white'} mt={'3%'} >
                  OrderOnline dapat diintegrasikan secara mudah dengan tools favorit Anda. Seperti Facebook, Google, MailChimp, Zenziva, Waboxapp dan lainnya, Anda akan memiliki semua alat marketing yang Anda butuhkan untuk meningkatkan omzet.</Text>
              </Box>
              <Box>
                <Image src='https://orderonline.id/wp-content/uploads/2019/03/iNTEGRASI-3-1.png' />
              </Box>
            </SimpleGrid>
          </Stack>

          <Box
            mt='3em'
            id='faq'
            // bg={'red'}
            w={'90%'}
            mx={'auto'}
          >
            <Box textAlign='center' py={8}>
              <Text color='black' fontSize={['1.5em', '2em', '3em']} fontWeight={700}>Pertanyaan Umum (FAQ)</Text>
              <Accordion allowMultiple mt={8}>
                {faq.map((x, i) => (
                  <AccordionItem key={i} borderRadius='lg' bg='white' p={2}>
                    <AccordionButton _hover={{ bg: 'gray.100' }} _focus={{ boxShadow: 'outline' }}>
                      <Box flex='1' textAlign='left'>
                        <Text color='black' fontWeight='bold'>{x.q}</Text>
                      </Box>
                      <AccordionIcon color='black' />
                    </AccordionButton>
                    <AccordionPanel borderTopWidth='1px' borderColor='gray.200' pt={2}>
                      <Text color='black' textAlign='left'>{x.a}</Text>
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </Box>
          </Box>

          <Box bg='#F0F8FF' color={useColorModeValue('gray.700', 'gray.200')}>
            <Container as={Stack} maxW={'6xl'} py={10}>
              <SimpleGrid
                templateColumns={{ sm: '1fr 1fr', md: '2fr 1fr 1fr 2fr' }}
                spacing={8}>
                <Stack spacing={6}>
                  <Box>
                    <Image
                      src='https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/ca/6c/90/ca6c90e7-42d8-e85f-536d-0b2fbeb19c84/AppIcon-1x_U007epad-85-220.png/246x0w.webp'
                      width='50%'  // Atur lebar gambar
                      height='100%' // Atur tinggi gambar
                      borderRadius='50%' // Membuat gambar menjadi lingkaran
                    />
                  </Box>
                  <Stack direction={'row'} spacing={6}>
                    <SocialButton label={'Twitter'} href={'#'}>
                      <FaTwitter />
                    </SocialButton>
                    <SocialButton label={'YouTube'} href={'#'}>
                      <FaYoutube />
                    </SocialButton>
                    <SocialButton label={'Instagram'} href={'#'}>
                      <FaInstagram />
                    </SocialButton>
                  </Stack>
                </Stack>
                <Stack align={'flex-start'}>
                  <ListHeader>Company</ListHeader>
                  <Box as='a' href={'#'}>
                    About us
                  </Box>
                  <Box as='a' href={'#'}>
                    Blog
                  </Box>
                  <Box as='a' href={'#'}>
                    Contact us
                  </Box>
                  <Box as='a' href={'#'}>
                    Pricing
                  </Box>
                  <Box as='a' href={'#'}>
                    Testimonials
                  </Box>
                </Stack>
                <Stack align={'flex-start'}>
                  <ListHeader>Support</ListHeader>
                  <Box as='a' href={'#'}>
                    Help Center
                  </Box>
                  <Box as='a' href={'#'}>
                    Terms of Service
                  </Box>
                  <Box as='a' href={'#'}>
                    Legal
                  </Box>
                  <Box as='a' href={'#'}>
                    Privacy Policy
                  </Box>
                  <Box as='a' href={'#'}>
                    Satus
                  </Box>
                </Stack>
              </SimpleGrid>
            </Container>
          </Box>

          <Center mt={'-1em'} bg={'black'}>
            <Text textColor={'white'}>©deoapp.crm All rights reserved.</Text>
          </Center>
        </Stack>
      </Stack></>
  );
};

export default HomeMainPage;